import { formatToUSD, normalizeProductData } from "@/app/utils/utility";
import { Caption, Paragraph, Title } from "@/components/ui/typography";
import { ToastClose } from "../ui/toast";

export default function CartSnackbar({ product, quantity,cartInputValue,inputQuantity, title }) {
  if (!product) return null;
  const productDetails = !product?.isNormalized
  ? { ...normalizeProductData(product) }
  : product;
  const { name, modelNumber, img } = productDetails;
  const addedItemQty = cartInputValue?.find((cart)=>cart.id === product.id)
  return (
    <div>
      <ToastClose className="absolute right-[5%] top-[16px] " />
      <Title size="xs">{title}</Title>
      <div className="w-full flex items-center justify-between mt-3 gap-4 max-w-[495px]">
        <div className="h-[100px] w-[98px] bg-midnightIndigo-100 flex items-center rounded">
          <img
            height={100}
            width={90}
            src={img?.imagePath}
            alt={img?.imageAlt}
            className="object-contain h-[100px] w-[90]"
          />
        </div>
        <div className="flex w-full flex-col">
          <Caption className="mb-1">{modelNumber || "-"}</Caption>
          <div className="flex justify-between flex-row">
            <Paragraph
              variant="medium"
              className="max-w-[60%] line-clamp-2 text-midnightIndigo-400"
            >
              {name}
            </Paragraph>
            <div className="">
              <Caption className={""}>
                {formatToUSD(
                 productDetails?.isFlash == null
                 ? productDetails?.discountedPrice?.rawValue
                 : productDetails?.isFlash
                )}{" "}
                x {quantity}
              </Caption>
              <Title size="xs" className="text-right">
                {formatToUSD(
                  (productDetails?.isFlash == null
                    ? productDetails?.discountedPrice?.rawValue
                    : productDetails?.isFlash) * (quantity)
                )}
              </Title>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
